export default __webpack_public_path__ + "static/media/calendar.389308ea.svg";